import { Component, OnInit, ViewChild, Output, EventEmitter, Input, Self } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ToastService, MdbCheckboxChange } from 'ng-uikit-pro-standard';
import { RecorridoService } from 'src/app/services/recorrido.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { RuteadorService } from 'src/app/services/ruteador.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import gql from 'graphql-tag';
import * as _ from 'lodash';
import { Observable, Subscription } from 'rxjs';
import { DatesService } from 'src/app/shared/services/dates.service';
import { Subject } from 'rxjs';
import { CamionSucursalService } from 'src/app/services/camion-sucursal.service';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';

@Component({
  selector: 'app-modal-clonar-recorrido',
  templateUrl: './modal-clonar-recorrido.component.html',
  styleUrls: ['../ruteador.component.scss'],
  providers: [SecurityService],
})
export class ModalClonarRecorridoComponent implements OnInit {
  @ViewChild('modalClonarRecorrido', { static: true }) modalClonar: ModalDirective;
  eventsSubject: Subject<void> = new Subject<void>();

  // Input
  @Input() title: String = '';
  @Input() contentText: String = '';
  @Input() acceptButtonText: String = 'Aceptar';
  @Input() cancelButtonText: String = 'Cancelar';

  // Output
  @Output() onAccept: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();
  FechaRec: string = null;
  loading = false;
  // Callbacks
  private acceptCallback: Function;
  private cancelCallback: Function;
  processing: boolean = false;
  listRecorridosCheck: any = [];
  public rutEmpresa;
  public sucursalCodigo;
  // Utils
  private log: any;
  camion: any;
  optionsUnidadesDeNegocio: unidad_negocio[] = [];

  optionsCamion: Array<any> = [];

  constructor(
    private datesService: DatesService,
    private accesolocalstorage: SecurityService,
    private _messageRendererService: MessageRendererService,
    private recorridoService: RecorridoService,
    private camionService: CamionSucursalService,
    private toastrService: ToastService
  ) { }

  ngOnInit() {
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursalCodigo = this.accesolocalstorage.getSucursalCodigo();

    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.FechaRec = currentDate;

    this.loadCamiones();
  }

  /********* SHOW/HIDE *********/
  show(listRecorridos, acceptCallback: Function = null, cancelCallback: Function = null) {
    console.log('ENTRA EN LA SEGUNDA FUNCION', listRecorridos);
    this.listRecorridosCheck = listRecorridos;
    this.acceptCallback = acceptCallback;
    this.cancelCallback = cancelCallback;
    this.modalClonar.show();
  }

  hide() {
    this.modalClonar.hide();
    return new Promise((resolve) => {
      setTimeout(() => {
        this.processing = false;
      }, 1000);
    });
    //this.processing = false
  }
  /********* SHOW/HIDE *********/

  /********* OPERATIONS *********/
  async accept() {
    const { currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.processing = true;

    this.listRecorridosCheck.map((x) => {
      x.fecha = this.FechaRec;
    });

    const hayDuplicados = this.verificarDuplicados(this.listRecorridosCheck);

    // if(recorridosDuplicados.length > 0){
    //    this.toastrService.warning("Existen recorridos duplicados");
    //   return;
    // }

    if (hayDuplicados) {
      this.toastrService.warning('Existen recorridos duplicados');
      this.processing = false;
      return;
    } else {
      const self = this;
      //Realizar operacion de crear ruta segun la cantidad de recorridos.
      this.listRecorridosCheck.forEach((element) => {
        element.codigo = null;
        element.chofer_rut = element.chofer_rut;
        element.camion_patente = element.patente;
        element.sucursal_codigo = this.sucursalCodigo;
        element.rut_empresa = this.rutEmpresa;
        element.limite_volumen = this.setCamion(element.patente, 1);
        element.limite_monto = 10000000;
        element.limite_peso = this.setCamion(element.patente, 0);
        element.fecha_registro = this.FechaRec;
        element.fecha = this.FechaRec;
        element.activo = true;

        delete element.patente;
        delete element.recorrido_codigo;
        delete element.descripcion_camion;
        delete element.nombre_chofer;
        delete element.total_facturas;
        delete element.__typename;
        delete element.checked;
        delete element.index;
      });

      const inputParams = {
        entidad: this.listRecorridosCheck,
      };

      console.log('Carga Finalizada ', inputParams);
      await this.capturarMovimientoMaquina(inputParams);

      this.toastrService.success('Operación exitosa');

      this.FechaRec = currentDate;
      console.log('Función externa completada. Continuando con la función principal');

      this.onAccept.emit();
      await this.hide();
    }
  }

  async capturarMovimientoMaquina(inputParams) {
    const self = this;
    const a = await new Promise((resolve) => {
      // Simulamos una operación asincrónica con setTimeout
      setTimeout(() => {
        this.recorridoService.GuardarRecorridoClonacion(inputParams, ({ mensajes, respuesta }) => {
          const ok = respuesta !== null;

          if (mensajes && mensajes.length > 0) {
            self._messageRendererService.showErrors(mensajes);
            self.processing = false;
            return;
          }

          if (mensajes.length == 0 && respuesta.length == 0) {
            self.toastrService.error('No se han encontrado recorrido para clonar');
            self.processing = false;
            return;
          }

          if (!ok) {
            self._messageRendererService.showErrors(mensajes);
            self.processing = false;
            return;
          }

          const { codigo } = respuesta;
          resolve(codigo);
        });
      }, 1000);
    });

    return await Promise.resolve(a);
  }

  // Función para verificar duplicados en la lista
  verificarDuplicados(lista: any): boolean {
    const combinacionesVistas: Set<string> = new Set();

    for (const objeto of lista) {
      const combinacion = `${objeto.chofer_rut}-${objeto.patente}`;

      if (combinacionesVistas.has(combinacion)) {
        // Duplicado encontrado
        return true;
      }

      // Agregar la combinación a la lista de combinaciones vistas
      combinacionesVistas.add(combinacion);
    }

    // No se encontraron duplicados
    return false;
  }

  loadCamiones() {
    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalCodigo,
      tipobusqueda: 1,
    };

    this.optionsUnidadesDeNegocio = [];

    this.camionService.obtenerCamionSucursalxRutEmpresaSucursal(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this._messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;
      this.optionsCamion = registros.map((p) => ({ value: p.patente, label: p.patente + ' - ' + p.descripcion, ...p }));
    });
  }

  setCamion(patente, atributo) {
    this.camion = this.optionsCamion.filter((s) => s.value == patente)[0];

    if (atributo == 1) {
      return this.camion.volumen;
    } else {
      return this.camion.peso_maximo;
    }
  }

  cancel() {
    if (this.cancelCallback) this.cancelCallback();
    this.onCancel.emit();
    this.hide();
  }
  /********* OPERATIONS *********/
}
